<template>
    <div class="threeContent">
        <div class="header">
            <div class="title">
                <span class="before"></span>
                <span
                    style="color: rgb(0, 102, 204);cursor:pointer;margin-left:5px;"
                    @click="toThree"
                    >三层任务</span
                >
                > 文件管理
            </div>
            <usage ref="usage"></usage>
            <div class="right">
                <div
                    :title="
                        'exe、bat、ps1、rar、zip、7z、reg、txt、dll、ini、cfg、doc、docx、xls、xlsx、jpg、gif、png、bmp、vbs'
                    "
                >
                    <img
                        class="type"
                        src="@/assets/img/icon/u1488.png"
                        alt=""
                    />
                    支持的文件类型
                </div>
                <file-upload
                    ref="fileUpload"
                    :format="[
                        'exe',
                        'bat',
                        'ps1',
                        'rar',
                        'zip',
                        '7z',
                        'reg',
                        'txt',
                        'dll',
                        'ini',
                        'cfg',
                        'doc',
                        'docx',
                        'xls',
                        'xlsx',
                        'jpg',
                        'gif',
                        'png',
                        'bmp',
                        'vbs',
                    ]"
                    :url="$HTTP_API.threeTierMission.uploadFile"
                    :size="32768"
                    @fileResult="getFileList(1)"
                ></file-upload>
            </div>
        </div>
        <!-- 表格部分 -->
        <div class="table-content">
            <table-list
                ref="tableList"
                @pagechange="getFileList"
                @delAllFile="delAllFile"
                @refresh="refresh"
                :total="parseInt(total)"
                :page="parseInt(page)"
                :table-list="fileList"
                :loading="loading"
            ></table-list>
        </div>
    </div>
</template>

<script>
// 网吧列表
import TableList from "./tableList";
import usage from "../modal/usage";
import FileUpload from "_c/uploadFile"; // 引入上传文件组件
import { getFileList, delFile } from "@/requests/threeTierMission";
export default {
    name: "threeTierMission",
    components: {
        TableList,
        usage,
        FileUpload,
    },
    data() {
        return {
            total: 0,
            page: 1,
            fileList: [],
            loading: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.getFileList(1);
            vm.$refs.usage.getUsage();
        });
    },
    methods: {
        // 获取所有网吧列表
        async getFileList(current) {
            this.$refs.usage.getUsage();
            this.loading = true;
            let res = await getFileList({
                current,
                size: 30,
            });
            this.loading = false;
            this.fileList = res.data.records;
            this.total = parseInt(res.data.total);
            this.page = parseInt(res.data.current);
        },
        toThree() {
            this.$router.push({
                path: this.$PAGE_API.home.children.threeTierMission.path,
            });
        },
        delAllFile() {
            if (this.$refs.tableList.selectedFileIds().length == 0) {
                return window.$Message.show({
                    title: "提示",
                    type: "error",
                    msg: "请选择文件",
                });
            }
            window.$Message.show({
                title: "删除文件",
                type: "error",
                msg: "确定将选中的文件删除掉吗？",
                cancleBtn: true,
                confirmFn: async () => {
                    let res = await delFile({
                        fileId: this.$refs.tableList
                            .selectedFileIds()
                            .join(","),
                    });
                    if (res.code === 200) {
                        window.$Message.hide();
                        this.getFileList(
                            this.$del.delPage(
                                this.total,
                                this.$refs.tableList.selectedFileIds().length,
                                30,
                                this.page
                            )
                        );
                    } else {
                        window.$Message.hide();
                        setTimeout(() => {
                            window.$Message.show({
                                title: "删除文件",
                                type: "error",
                                msg: res.msg,
                                confirmFn: () => {
                                    window.$Message.hide();
                                    window.$Message.confirmFn = null;
                                },
                            });
                        }, 100);
                    }
                },
            });
        },
        refresh(page) {
            if (page) {
                this.getFileList(page);
            } else {
                this.getFileList(this.page);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.threeContent {
    position: absolute;
    min-width: 1140px;
    left: 0px;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    overflow-y: auto;
}
.header {
    padding-left: 30px;
    text-align: left;
    position: relative;
    z-index: 10;
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #d9dee4;
    .title {
        float: left;
        font-size: 14px;
        span.before {
            display: inline-block;
            width: 2px;
            height: 14px;
            background: #0099cc;
            position: relative;
            top: 2px;
        }
    }
}
.right {
    float: right;
    padding-right: 20px;
    div {
        float: left;
        margin-left: 10px;
        cursor: pointer;
    }
    .type {
        position: relative;
        top: 2px;
    }
    a {
        margin-left: 6px;
        line-height: normal;
    }
}
.table-content {
    padding-top: 10px;
    padding-left: 30px;
    padding-right: 30px;
}
.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
    }
}
</style>
